import {Component, Input, OnInit} from '@angular/core';
import {Zalozka} from '../model/zalozka';

@Component({
    selector: 'app-zalozka',
    templateUrl: './zalozka.component.html',
    styleUrls: ['./zalozka.component.css'],
    standalone: false
})
export class ZalozkaComponent implements OnInit {

  @Input()
  zalozka: Zalozka;

  constructor() { }

  ngOnInit() {
  }

}
